import React, { Component } from "react";
import {
  reduxForm,
  change,
  submit as submitForm,
  formValueSelector,
} from "redux-form";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';

import SliderCommonComponent from "../../../Common/SliderCommonComponent/SliderCommonComponent";
import Loader from '../../../Loader';
import submit from "../../SearchForm/submit";
import { url } from "../../../../config";
import { isRTL } from '../../../../helpers/formatLocale';
import { HOME_TYPE_FILTERS, SLIDER_FILTER_IDS } from "../../../../config/homeTypeFilters";

import DefaultIcon from "/public/SiteIcons/defaultIcon.png";

import s from "./HomeTypeSlider.css";


class HomeTypeSlider extends Component {

  constructor(props) {
    super(props);
    if (typeof window !== 'undefined') {
      this.swiperPackage = require('swiper/react');
    }
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    setTimeout(() => { this.setState({ loaded: true }) }, 1)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { locale } = this.props.intl;
    const { locale: prevLocale } = nextProps.intl;
    if (locale !== prevLocale) {
      this.setState({
        loaded: false
      }, () => {
        setTimeout(() => {
          this.setState({
            loaded: true
          })
        }, 1);
      });
    }
  }

  isFilterActive = (itemId) => {
    const { isActiveRoomType, amenities } = this.props;
    const filterConfig = HOME_TYPE_FILTERS[itemId];

    if (!filterConfig) {
      // Default: check if it's the active room type
      return itemId == isActiveRoomType;
    }

    if (filterConfig.type === 'amenity') {
      // Check if amenity is in amenities array
      return amenities?.includes(filterConfig.amenityId);
    } else {
      // For roomType and houseType, check if it's the active one
      return itemId == isActiveRoomType;
    }
  }

  handleSubmitButton = async (itemId) => {
    const { handleSubmit, change, amenities } = this.props;

    // Get filter configuration for this item
    const filterConfig = HOME_TYPE_FILTERS[itemId];

    if (filterConfig) {
      if (filterConfig.type === 'amenity') {
        // Toggle amenity filter
        let updatedAmenities = [...(amenities || [])];
        const amenityId = filterConfig.amenityId;

        if (updatedAmenities.includes(amenityId)) {
          updatedAmenities = updatedAmenities.filter(id => id !== amenityId);
        } else {
          updatedAmenities.push(amenityId);
        }

        await change('amenities', updatedAmenities);
        await change('isActiveRoomType', null); // Clear room type selection
      } else if (filterConfig.type === 'houseType') {
        // Set house type filter - use houseTypeIds array if available (for duplicates)
        const houseTypeIds = filterConfig.houseTypeIds || [itemId];
        await change('houseType', houseTypeIds);
        await change('isActiveRoomType', itemId);
        await change('roomType', []); // Clear room type selection
      } else {
        // Default: room type filter
        await change('roomType', [itemId]);
        await change('isActiveRoomType', itemId);
        await change('houseType', []); // Clear house type selection
      }
    } else {
      // Fallback: treat as room type (backward compatibility)
      await change('roomType', [itemId]);
      await change('isActiveRoomType', itemId);
      await change('houseType', []);
    }

    await change('currentPage', 1);
    await handleSubmit();
    window.scrollTo({
      top: 0,
      left: 0
    });
  }

  render() {
    const { allSettingsById, intl: { locale }, updatedLocale } = this.props;
    const { SwiperSlide } = this.swiperPackage;
    const { loaded } = this.state;

    let breakPoints = {
      991: {
        slidesPerGroup: 5,
      },
      767: {
        slidesPerGroup: 3,
      }
    };

    // Get filter items from the store using hardcoded IDs
    const filterItems = allSettingsById
      ? SLIDER_FILTER_IDS.map(id => allSettingsById[id]).filter(item => item)
      : [];

    return (
      <div className={'homeTypeSwiper'}>
        {
          !updatedLocale && loaded && filterItems.length > 0 ? (
            <SliderCommonComponent spaceBetween={30} slidesPerGroup={6} slidesPerView={'auto'} breakpoints={breakPoints} rtl={isRTL(locale)}>
              {
                filterItems.map((item, key) => {
                  const isActive = this.isFilterActive(item?.id);
                  return (
                    <SwiperSlide key={key}>
                      <div
                        onClick={() => this.handleSubmitButton(item?.id)}
                        className={cx(s.activeBorderColorHover, { [s.activeBorderColor]: isActive })}
                      >
                        <div className={s.homeTypeSlider}>
                          <div className={cx(s.homeTypeImage)}>
                            <img
                              src={item?.icon || (item?.image ? url + "/images/amenities/" + item?.image : DefaultIcon)}
                              className={cx(s.homeTypeImageShadow, { [s.activeColor]: isActive })}
                            />
                          </div>
                          <div className={cx(s.typeName, { [s.typeNameColor]: isActive })}>
                            {locale === 'fr-FR' && item?.itemNameFR ? item.itemNameFR : item?.itemName}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })
              }
            </SliderCommonComponent>
          ) : <Loader type={"text"} />
        }

      </div >
    );
  }
}

HomeTypeSlider = reduxForm({
  form: "SearchForm",
  onSubmit: submit,
  destroyOnUnmount: false,
})(HomeTypeSlider);

const selector = formValueSelector('SearchForm')

const mapState = (state) => ({
  isActiveRoomType: selector(state, 'isActiveRoomType'),
  amenities: selector(state, 'amenities'),
  allSettingsById: state?.listingFields?.data?.allSettingsById,
  updatedLocale: state?.intl?.newLocale,
});

const mapDispatch = {
  change,
  submitForm,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(HomeTypeSlider))
);
